/** Who is signed in, and how to stop being signed in.
 *
 * In the top bar, and the **role stays visible there** (it is on `UserMenu`'s trigger): it decides
 * whether the person can verify a figure, and a UI that hides the current role invites "why is the
 * button disabled?", whose answer is always the role.
 *
 * Signing out clears the whole query cache (`useLogout`), which is why it is not just a link. A
 * cache left populated would render one organisation's figures to whoever signs in next on a shared
 * machine — and a shared machine is the normal case on a factory floor.
 */

import { Link } from "@tanstack/react-router";

import { useMe } from "../api/auth";
import styles from "./SessionBadge.module.css";
import { UserMenu } from "./UserMenu";

export function SessionBadge() {
  const { data: me, isPending } = useMe();

  // Nothing at all while the first check is in flight. A "Sign in" link that appeared for half a
  // second on every load, for someone who *is* signed in, would look like a bug every time.
  if (isPending) return null;

  if (!me) {
    return (
      <Link className={styles.signIn} to="/sign-in" search={{ method: "location" }}>
        Sign in
      </Link>
    );
  }

  // The name, the role and sign-out are in the menu now (card C-A). Signing out clears the whole
  // query cache (`useLogout`), which is why it is a mutation and not a link, and that has not
  // changed by moving it.
  return <UserMenu me={me} />;
}
